import { ButtonBase } from "@mui/material";
import { Popover } from "antd";
import { useEffect, useState } from "react";

const LoanSwitchBoxList = (props) => {
    const { tabs, handler, activeTabId } = props;
    const [tabIdx, setTabIdx] = useState(0);
    const handleSwitch = (idx, name) => {
        setTabIdx(idx);
        if (handler) {
            handler(name);
        }
    }
    return (
        <div className={`switch_tab mr-[20px] mb-[15px] inline-block p-[10px_0px] max-w-full`}>
            <div className="rounded-[4px] bg-[#F5F5F5] p-[3px] flex max-[768px]:overflow-x-scroll">
                {
                    tabs.map((tab, idx) => {
                        return (
                            <ButtonBase key={idx}>
                                <span className={`switch whitespace-nowrap ${activeTabId === tab.id && 'active'}`} onClick={() => handleSwitch(idx, tab.id)} >{tab.name}</span>
                            </ButtonBase>
                        )
                    })
                }
            </div>
        </div>
    )
};

export default LoanSwitchBoxList;
